function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Controller } from 'react-hook-form';
import { Select } from "../../../../../Components/Forms";
import { Translate } from "../../../../../../I18N";
import { useAtomValue } from 'jotai';
import { settingsAtom } from "../../../../../atoms";






export const PropertyTypeField = ({ control, disabled }) => {
  const settings = useAtomValue(settingsAtom);

  const propertyTypeOptions = [
  { value: 'text', label: 'Text' },
  { value: 'markdown', label: 'Rich text' },
  { value: 'numeric', label: 'Numeric' },
  { value: 'date', label: 'Date' },
  { value: 'multidate', label: 'Multiple dates' },
  { value: 'daterange', label: 'Date range' },
  { value: 'multidaterange', label: 'Multiple date ranges' },
  { value: 'select', label: 'Select' },
  { value: 'multiselect', label: 'Multiple select' },
  { value: 'relationship', label: 'Relationship' },
  { value: 'link', label: 'Link' },
  { value: 'image', label: 'Image' },
  { value: 'preview', label: 'Preview' },
  { value: 'media', label: 'Media' },
  { value: 'geolocation', label: 'Geolocation' },
  { value: 'generatedid', label: 'Generated ID' }];


  //i shall not fear walking through the valley of death
  if (settings.project === 'cejil') {
    propertyTypeOptions.push({ value: 'nested', label: 'Violated articles' });
  }

  return (/*#__PURE__*/
    _jsx(Controller, {
      name: "type",
      control: control,
      rules: { required: true },
      render: ({ field }) => /*#__PURE__*/
      React.createElement(Select, _extends({
        id: "property-type",
        label: /*#__PURE__*/
        _jsx("div", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Property type"), /*#__PURE__*/
        _jsx("span", {}, void 0, "*")
        ),

        options: propertyTypeOptions,
        disabled: disabled },
      field)
      ) }

    ));

};